import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logos.png';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [logoClickCount, setLogoClickCount] = useState(0);
  const [activeSection, setActiveSection] = useState('');
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Определяем активную секцию
      const sections = ['services', 'reviews'];
      const scrollPosition = window.scrollY + 100;

      let currentSection = '';

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            currentSection = section;
            break;
          }
        }
      }

      // Проверяем footer-contacts отдельно
      const footerElement = document.getElementById('footer-contacts');
      if (footerElement) {
        const { offsetTop } = footerElement;
        if (scrollPosition >= offsetTop) {
          currentSection = 'footer-contacts';
        }
      }

      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Вызываем сразу для начальной проверки
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      // Если уже в этой секции, делаем пульсацию
      if (activeSection === sectionId) {
        section.classList.add('highlight-section');
        setTimeout(() => {
          section.classList.remove('highlight-section');
        }, 1000);
      }
      section.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleLogoClick = (e) => {
    if (isHomePage) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      setLogoClickCount(prev => prev + 1);
      if (logoClickCount >= 6) {
        const logoElement = e.currentTarget;
        logoElement.classList.add('rainbow');
        setTimeout(() => {
          logoElement.classList.remove('rainbow');
        }, 2000);
        setLogoClickCount(0);
      }
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link 
            to="/" 
            className="logo"
            onClick={handleLogoClick}
          >
            <img src={logo} alt="Мигрант PRO" className="logo-img" />
          </Link>

          <nav className={`nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <a 
              href="#services" 
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('services');
              }}
              className={activeSection === 'services' ? 'active' : ''}
            >
              Услуги
            </a>
            <a 
              href="#reviews" 
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('reviews');
              }}
              className={activeSection === 'reviews' ? 'active' : ''}
            >
              Отзывы
            </a>
            <a 
              href="#footer-contacts" 
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('footer-contacts');
              }}
              className={activeSection === 'footer-contacts' ? 'active' : ''}
            >
              Контакты
            </a>
            <a 
              href="#form" 
              className="nav-cta" 
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('form');
              }}
            >
              Оставить заявку
            </a>
          </nav>

          <a href="tel:+79257166607" className="phone-link">
            <Phone size={20} />
            <span>+7 (925) 716-66-07</span>
          </a>

          <button 
            className="mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;